<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <b-form-datepicker
          :value="filters.createdTo"
          :locale="this.$i18n.locale"
          @input="onChangeFilter('createdTo', $event)"
        ></b-form-datepicker>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <b-overlay :show="areItemsLoading">
          <v-select
            :value="filters.goods"
            :clearable="false"
            :options="availableItems"
            :getOptionLabel="x => `${x.title[$i18n.locale]} - ${x.code}`"
            @input="onChangeFilter('goods', $event)"
            :placeholder="$t('transactions.sold-items-searcher.select-placeholder')"
          >
            <template v-slot:no-options>{{ $t("vselect.noOptions") }}</template>
          </v-select>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@/services/api.js";

export default {
  data() {
    return {
      areItemsLoading: false,
      availableItems: []
    };
  },
  computed: {
    filters() {
      return this.$store.getters["soldItemsTransactions/filters"];
    }
  },
  methods: {
    onChangeFilter(property, value) {
      this.$store.dispatch("soldItemsTransactions/setFilter", { property, value });
    }
  },
  mounted() {
    this.areItemsLoading = true;
    api
      .getSaleableGoods()
      .then(resp => (this.availableItems = resp.data))
      .catch(() => alert(this.$t("transactions.sold-items-searcher.error.general")))
      .finally(() => (this.areItemsLoading = false));
  }
};
</script>
